module.exports = __webpack_public_path__ + "img/20180815_152858_226.e035de24.jpg";